import Card from '@/components/card';
import { Container, Main, Title } from '@/components/container';
import { NsList } from '@/components/customElements';
import Layout from '@/components/layout';
import { Tags } from '@/components/tags';
import { graphql } from 'gatsby';
import React from 'react';
import styled from 'styled-components';
import media from 'styled-media-query';

type Props = {
  data: GatsbyTypes.PostsIndexQuery;
};
const PostsContainer = styled(Container)`
  grid-template:
    'title title title' auto
    '. main tags' auto / 1fr var(--main-width) 1fr;
  ${media.lessThan('large')`
    grid-template:
    'title .' auto
    'main tags' auto / var(--main-width) 1fr;
  `}
  ${media.lessThan('medium')`
    grid-template:
    'title' auto
    'tags' auto
    'main' auto / var(--main-width);
  `}
`;
const List = styled(NsList)`
  display: grid;
  grid-template-columns: repeat(auto-fit, var(--card-width));
  gap: var(--card-gap);
  justify-content: center;
`;
const PostsPage: React.VFC<Props> = ({ data: { site, allFile, tags } }) => (
  <Layout type="post" desc="POST一覧" siteMetadata={site.siteMetadata}>
    <PostsContainer>
      <Title>Posts</Title>
      <Main>
        <List>
          {allFile.nodes.map((node) => (
            <li key={node.name}>
              <Card {...node} type="post" />
            </li>
          ))}
        </List>
      </Main>
      <Tags tags={tags} type="post" />
    </PostsContainer>
  </Layout>
);

export const query = graphql`
  query PostsIndex {
    allFile(
      filter: { sourceInstanceName: { eq: "posts" } }
      sort: { fields: childMarkdownRemark___frontmatter___date, order: DESC }
    ) {
      nodes {
        name
        childMarkdownRemark {
          frontmatter {
            date(formatString: "YYYY/MM/DD")
            title
            tags
            thumbnail {
              childImageSharp {
                gatsbyImageData(
                  placeholder: BLURRED
                  formats: [AUTO]
                  layout: FULL_WIDTH
                )
              }
            }
          }
        }
      }
    }
    tags: allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/posts//" } }
    ) {
      group(field: frontmatter___tags) {
        name: fieldValue
        totalCount
      }
    }
    site {
      siteMetadata {
        title
        siteUrl
        description
      }
    }
  }
`;

export default PostsPage;
